import { supabaseClient } from './supabaseClient.js';

// 4. Lưu Giao dịch chính & Cập nhật số dư
export async function saveTransactionToDB(txnData) {
    
    // B1: Insert vào bảng transactions
    const { data: txn, error: txnErr } = await supabaseClient.from('transactions').insert([txnData]).select().single();
    if (txnErr) { console.error('[API] Lỗi lưu Giao dịch:', txnErr.message); return null; }

    // B2: Cập nhật số dư Wallet
    const { data: wallet } = await supabaseClient.from('wallets').select('balance, usage_count').eq('id', txnData.wallet_id).single();
    if (wallet) {
        let newBalance = Number(wallet.balance);
        if (txnData.type === 'income') newBalance += Number(txnData.amount);
        else if (txnData.type === 'expense') newBalance -= Number(txnData.amount);

        await supabaseClient.from('wallets').update({ 
            balance: newBalance, 
            usage_count: (wallet.usage_count || 0) + 1 
        }).eq('id', txnData.wallet_id);
    }

    // B3: Tăng đếm usage_count cho Category và Tag (Để sắp xếp tối ưu)
    if (txnData.category_id) {
        const { data: cat } = await supabaseClient.from('categories').select('usage_count').eq('id', txnData.category_id).single();
        if (cat) await supabaseClient.from('categories').update({ usage_count: (cat.usage_count || 0) + 1 }).eq('id', txnData.category_id);
    }
    if (txnData.tag_id) {
        const { data: tag } = await supabaseClient.from('tags').select('usage_count').eq('id', txnData.tag_id).single();
        if (tag) await supabaseClient.from('tags').update({ usage_count: (tag.usage_count || 0) + 1 }).eq('id', txnData.tag_id);
    }

    return txn; // Trả về Full Object thay vì true
}

export async function saveTransferToDB(fromTxnData, toTxnData) {
    
    // Lưu From (Expense) trước
    const txnFrom = await saveTransactionToDB(fromTxnData);
    if (!txnFrom) {
        console.error('[API] Lỗi lưu giao dịch trừ tiền (Transfer Out)');
        return false;
    }
    
    // Gắn ID của From vào To (Income) làm liên kết
    toTxnData.linked_txn_id = txnFrom.id;
    const txnTo = await saveTransactionToDB(toTxnData);
    if (!txnTo) {
        console.error('[API] Lỗi lưu giao dịch cộng tiền (Transfer In)');
        return false;
    }

    // (Tuỳ chọn) Đánh dấu chéo lại cho From (để query 2 chiều). Update ko thay đổi số dư nên chỉ dùng supabaseClient update chay.
    await supabaseClient.from('transactions').update({ linked_txn_id: txnTo.id }).eq('id', txnFrom.id);

    return true;
}

// 6. Lấy danh sách Lịch sử Giao dịch
export async function fetchTransactions(limit = 5000) {
    
    const { data, error } = await supabaseClient
        .from('transactions')
        .select(`
            id, amount, currency, base_amount, exchange_rate, type, remark, transaction_date, linked_txn_id,
            wallet_id, category_id, tag_id, category_name, tag_name,
            wallets!wallet_id (name),
            categories (name),
            tags (name)
        `)
        .order('transaction_date', { ascending: false })
        .order('created_at', { ascending: false })
        .limit(limit);

    if (error) {
        console.error('[API] Lỗi tải giao dịch:', error.message);
        return [];
    }
    
    return data;
}

// 7. Xóa giao dịch và Hoàn tiền (Rollback Balance)
export async function deleteTransactionAndRefund(txn) {

    // KẾT TOÁN HOÀN TIỀN CỦA VÍ CHÍNH
    const { data: wallet } = await supabaseClient.from('wallets').select('balance').eq('id', txn.wallet_id).single();
    if (wallet) {
        let currentBalance = Number(wallet.balance);
        if (txn.type === 'expense') currentBalance += Number(txn.amount);
        else if (txn.type === 'income') currentBalance -= Number(txn.amount);
        await supabaseClient.from('wallets').update({ balance: currentBalance }).eq('id', txn.wallet_id);
    }

    // TÌM VÀ KẾT TOÁN HOÀN TIỀN CHO GIAO DỊCH LIÊN KẾT (NẾU LÀ TRANSFER)
    if (txn.linked_txn_id) {
        // Tìm Giao dịch linked
        const { data: linkedTxn } = await supabaseClient.from('transactions').select('*').eq('id', txn.linked_txn_id).single();
        if (linkedTxn) {
            const { data: linkedWallet } = await supabaseClient.from('wallets').select('balance').eq('id', linkedTxn.wallet_id).single();
            if (linkedWallet) {
                let linkedBal = Number(linkedWallet.balance);
                if (linkedTxn.type === 'expense') linkedBal += Number(linkedTxn.amount);
                else if (linkedTxn.type === 'income') linkedBal -= Number(linkedTxn.amount);
                await supabaseClient.from('wallets').update({ balance: linkedBal }).eq('id', linkedTxn.wallet_id);
            }
            // Supabase ON DELETE CASCADE sẽ tự xóa record linkedTxn, nhưng an toàn hơn thì ta xóa thủ công
            await supabaseClient.from('transactions').delete().eq('id', linkedTxn.id);
        }
    }

    // BƯỚC 2.2: Xóa record chính (SQL Cascade sẽ tự chém các khóa phụ nhưng Refund thì ta làm bằng JS trên rồi)
    const { error: delErr } = await supabaseClient.from('transactions').delete().eq('id', txn.id);
    
    if (delErr) { 
        console.error('[API] Lỗi xóa giao dịch:', delErr.message); 
        return false; 
    }
    
    return true; // Thành công
}

// 8. Cập nhật Giao dịch (Rollback Ví cũ & Apply Ví mới)
export async function updateTransactionFull(oldTxn, newData) {

    // 1. Hoàn tiền lại cho Ví cũ (Dựa trên data cũ)
    const { data: oldWallet } = await supabaseClient.from('wallets').select('balance').eq('id', oldTxn.wallet_id).single();
    if (oldWallet) {
        let revertBalance = Number(oldWallet.balance);
        if (oldTxn.type === 'expense') revertBalance += Number(oldTxn.amount);
        else if (oldTxn.type === 'income') revertBalance -= Number(oldTxn.amount);
        await supabaseClient.from('wallets').update({ balance: revertBalance }).eq('id', oldTxn.wallet_id);
    }

    // 2. Trừ tiền vào Ví mới (Dựa trên data mới)
    const { data: newWallet } = await supabaseClient.from('wallets').select('balance').eq('id', newData.wallet_id).single();
    if (newWallet) {
        let applyBalance = Number(newWallet.balance);
        if (newData.type === 'expense') applyBalance -= Number(newData.amount);
        else if (newData.type === 'income') applyBalance += Number(newData.amount);
        await supabaseClient.from('wallets').update({ balance: applyBalance }).eq('id', newData.wallet_id);
    }

    // 3. Cập nhật lại record trong bảng Transactions
    const { error } = await supabaseClient.from('transactions').update(newData).eq('id', oldTxn.id);
    if (error) { console.error('[API] Lỗi update giao dịch:', error.message); return false; }
    
    return true; // Thành công
}
